// removed by extract-text-webpack-plugin
module.exports = {"mu-modal":"mu-modal","muModal":"mu-modal","mu-modal__body":"mu-modal__body","muModalBody":"mu-modal__body","mu-modal__footer":"mu-modal__footer","muModalFooter":"mu-modal__footer"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/__future__/MediaUpload/MediaUploadModal.module.scss
// module id = 698
// module chunks = 0